import React from 'react';
import { InputNumber } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { actions, selectors, stateKeys } from '../../../model';
import { uploadingFieldNames } from '../../../config/uploadingStep';
import { getWorksheetLastRow } from '../../../lib/file';
import FormItem from '../../ui/FormItem/FormItem';

const fieldName = uploadingFieldNames.dataStartRow;

const valueSelector = (state) =>
  selectors.selectUploadingStepValue(state, fieldName);
const errorSelector = (state) =>
  selectors.selectUploadingStepError(state, fieldName);
const workbookSelector = (state) =>
  selectors.selectStateValue(state, stateKeys.workbook);
const sheetSelector = (state) =>
  selectors.selectUploadingStepValue(state, uploadingFieldNames.sheet);

const DataStartRowInput = () => {
  const value = useSelector(valueSelector);
  const errors = useSelector(errorSelector);
  const workbook = useSelector(workbookSelector);
  const selectedSheet = useSelector(sheetSelector);
  const dispatch = useDispatch();

  const sheetName = selectedSheet || workbook?.SheetNames?.[0];
  const lastRow = getWorksheetLastRow(workbook?.Sheets?.[sheetName]);

  return (
    <FormItem
      required
      label="Строка начала данных"
      errors={errors}
      extra="Указанная строка будет первой строкой импортируемых данных"
    >
      <InputNumber
        value={value}
        min={1}
        max={lastRow || undefined}
        precision={0}
        placeholder="Укажите номер строки"
        style={{ width: '100%' }}
        onChange={(row) => dispatch(actions.dataStartRowChangeAction(row))}
      />
    </FormItem>
  );
};

export default DataStartRowInput;
